import React from 'react';
import { useTranslation } from 'react-i18next';
import './sec5.css';
import BookingHero from '../common/headsec';

import img1 from '../../asserts/1.png';
import img2 from '../../asserts/2.png';
import img3 from '../../asserts/3.png';
import img4 from '../../asserts/4.png';
import img5 from '../../asserts/5.png';
import img6 from '../../asserts/6.png';
import img7 from '../../asserts/7.png';
import img8 from '../../asserts/8.png';

import icon1 from '../../asserts/Iconn1.png';
import icon2 from '../../asserts/iconn2.png';
import icon3 from '../../asserts/Iconn3.png';

import arrowIc from '../../asserts/ic.png';
import Sec5Card from '../common/Sec5Card';

const Sec5 = () => {
    const { t } = useTranslation();
    return (
        <>
            <section className='sec5'>
                <div className='sec5-container'>

                    <BookingHero
                        t1={t('sec5_hero_tag')}
                        t2={t('sec5_hero_t1')}
                        t3={t('sec5_hero_t2')}
                        text={t('sec5_hero_text')}
                    />

                    <div className='sec5-grid'>

                        <Sec5Card
                            image={img1}
                            badge={t('sec3_cat_concerts')}
                            title={t('sec5_music_title')}
                            desc={t('sec5_music_desc')}
                            date='March 30, 2026'
                            time='8:00 PM'
                            location='Madison Square Garden, NY'
                            icon1={icon1}
                            icon2={icon2}
                            icon3={icon3}
                            price='99'
                            b='sec5btn'
                            btntt={t('sec5_card_book')}
                            ic={arrowIc}
                        />

                        <Sec5Card
                            image={img2}
                            badge={t('sec3_cat_comedy')}
                            title={t('sec5_comedy_title')}
                            desc={t('sec5_comedy_desc')}
                            date='April 5, 2026'
                            time='7:30 PM'
                            location='Comedy Club, LA'
                            icon1={icon1}
                            icon2={icon2}
                            icon3={icon3}
                            price='45'
                            b='sec5btn'
                            btntt={t('sec5_card_book')}
                            ic={arrowIc}
                        />
                        <Sec5Card
                            image={img6}
                            badge={t('sec3_cat_community')}
                            showFreeBadge={true}
                            title={t('sec5_community_title')}
                            desc={t('sec5_community_desc')}
                            date='April 28, 2026'
                            time='5:00 PM'
                            location='Central Park, NY'
                            icon1={icon1}
                            icon2={icon2}
                            icon3={icon3}
                            isFree={true}
                            b='sec5btn'
                            btntt={t('sec5_card_book')}
                            ic={arrowIc}
                        />


                        <Sec5Card
                            image={img3}
                            badge={t('sec3_cat_talks')}
                            title={t('sec5_talk_title')}
                            desc={t('sec5_talk_desc')}
                            date='April 12, 2026'
                            time='2:00 PM'
                            location='Convention Center, SF'
                            icon1={icon1}
                            icon2={icon2}
                            icon3={icon3}
                            price='75'
                            b='sec5btn'
                            btntt={t('sec5_card_book')}
                            ic={arrowIc}
                        />

                        <Sec5Card
                            image={img4}
                            badge={t('sec3_cat_theatre')}
                            title={t('sec5_theatre_title')}
                            desc={t('sec5_theatre_desc')}
                            date='April 18, 2026'
                            time='6:00 PM'
                            location='Royal Theatre, London'
                            icon1={icon1}
                            icon2={icon2}
                            icon3={icon3}
                            price='120'
                            b='sec5btn'
                            btntt={t('sec5_card_book')}
                            ic={arrowIc}
                        />

                        <Sec5Card
                            image={img5}
                            badge={t('sec3_cat_workshops')}
                            title={t('sec5_workshop_title')}
                            desc={t('sec5_workshop_desc')}
                            date='April 22, 2026'
                            time='10:00 AM'
                            location='Art Studio, Brooklyn'
                            icon1={icon1}
                            icon2={icon2}
                            icon3={icon3}
                            price='65'
                            b='sec5btn'
                            btntt={t('sec5_card_book')}
                            ic={arrowIc}
                        />


                        <Sec5Card
                            image={img7}
                            badge='Food'
                            title={t('sec5_food_title')}
                            desc={t('sec5_food_desc')}
                            date='May 3, 2026'
                            time='12:00 PM'
                            location='Brooklyn Navy Yard, NY'
                            icon1={icon1}
                            icon2={icon2}
                            icon3={icon3}
                            price='30'
                            b='sec5btn'
                            btntt={t('sec5_card_book')}
                            ic={arrowIc}
                        />

                        <Sec5Card
                            image={img8}
                            badge='Tech'
                            showFreeBadge={true}

                            title={t('sec5_tech_title')}
                            desc={t('sec5_tech_desc')}
                            date='May 10, 2026'
                            time='7:00 PM'
                            location='WeWork HQ, San Francisco'
                            icon1={icon1}
                            icon2={icon2}
                            icon3={icon3}
                            price='25'
                            isFree={true}

                            b='sec5btn'
                            btntt={t('sec5_card_book')}
                            ic={arrowIc}
                        />

                    </div>
                </div>
            </section>
        </>
    );
};

export default Sec5;